if (!customElements.get('wonsis-announcement-ticker')) {
  customElements.define('wonsis-announcement-ticker', class extends HTMLElement {
    connectedCallback() {
      if (this.toggleHandler) return;
      this.toggleButton = this.querySelector('.ws-ticker__toggle');
      this.toggleHandler = () => {
        const paused = this.toggleAttribute('data-paused');
        this.toggleButton?.setAttribute('aria-pressed', String(paused));
        this.toggleButton?.setAttribute('aria-label', paused ? 'Resume scrolling announcements' : 'Pause scrolling announcements');
      };
      this.toggleButton?.addEventListener('click', this.toggleHandler);
    }
    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.toggleHandler);
      this.toggleHandler = null;
    }
  });
}
